// extracted by mini-css-extract-plugin
export default {"required":"specification-drawings_required__kTPEs"};